import { ServiceLocationDetailsObjectType } from '../api/type';
import { addressResponseType } from '@utils';

/**
 * Refer to the ServiceLocationDetailsType in the API documentation: https://wcc-dev-apim-external.developer.azure-api.net/api-details#api=wcc-highways-reports-api&operation=create&definition=ServiceLocationDetailsType
 * @param address
 * @returns ServiceLocationDetailsType
 */
export const convertAddressToServiceLocation = (
  address: addressResponseType,
): ServiceLocationDetailsObjectType => {
  const {
    address_line_1,
    address_line_2,
    town,
    county,
    postcode,
    country,
    UPRN,
    USRN,
    latitude,
    longitude,
  } = address;

  return {
    address_line_1,
    address_line_2,
    town_city: town,
    postcode,
    country,
    UPRN,
    USRN,
    latitude: latitude,
    longitude: longitude,
    county,
  };
};

/**
 * Refer to the ServiceLocationDetailsType in the API documentation: https://wcc-dev-apim-external.developer.azure-api.net/api-details#api=wcc-highways-reports-api&operation=create&definition=ServiceLocationDetailsType
 * @param serviceLocation
 * @returns addressResponseType
 */
export const convertServiceLocationToAddress = (
  serviceLocation: ServiceLocationDetailsObjectType,
): addressResponseType => {
  const {
    address_line_1,
    address_line_2,
    town_city,
    postcode,
    country,
    UPRN,
    USRN,
    latitude,
    longitude,
    county,
  } = serviceLocation;

  return {
    address_line_1,
    address_line_2,
    town: town_city,
    postcode,
    country,
    UPRN,
    USRN,
    latitude: latitude ? latitude.toString() : '',
    longitude: longitude ? longitude.toString() : '',
    county,
    full_address: `${address_line_1}, ${address_line_2}, ${town_city}, ${postcode}, ${country}`,
  };
};
